export const news = [
  {
    id: 'n01',
    title: '2024 暑期档票房创新高，现实题材成最大赢家',
    date: '2024-08-15',
    tag: '行业观察',
    summary: '今年暑期档总票房突破历史纪录，多部聚焦普通人生活的现实题材影片表现亮眼，观众口味正发生深刻变化。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20audience%20silhouettes%20facing%20a%20glowing%20screen%20deep%20blue%20darkness%20with%20warm%20orange%20light%2C%20editorial%20photography%20wide%20composition&width=800&height=450&seq=news-01&orientation=landscape',
    heat: 9210,
    content: [
      { type: 'paragraph', text: '随着最后一波观影热潮落下帷幕，2024 年暑期档正式收官。据不完全统计，档期总票房较去年同期增长近两成，创下历史新高。与往年不同的是，今年真正撑起票房大盘的，并非大制作特效片，而是一批聚焦普通人生活的现实题材作品。' },
      { type: 'paragraph', text: '从讲述小镇青年追梦的《追风少年》，到描绘都市平凡人群像的《城市微光》，这些影片没有华丽的视觉奇观，却凭借真挚的情感与扎实的剧本赢得了观众的口碑。多地影院经理表示，这些影片的上座率在工作日依然保持高位，回头客明显增多。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=warm%20cinema%20lobby%20with%20movie%20posters%20and%20soft%20golden%20lighting%2C%20editorial%20photography%20wide%20shot&width=1000&height=560&seq=news-detail-01&orientation=landscape', caption: '影院大厅里，观众正在讨论刚刚看完的影片。' },
      { type: 'paragraph', text: '业内分析人士指出，观众对“好故事”的需求正在回归。当特效不再是稀缺资源，能够引发共鸣的现实题材反而成为市场的稀缺品。这一趋势也促使更多创作者把镜头对准真实生活。' },
      { type: 'paragraph', text: '展望下半年，多部备受期待的影片已经定档。能否延续这股现实主义创作热潮，将成为观察中国电影市场走向的重要窗口。' },
    ],
  },
  {
    id: 'n02',
    title: '《星海归途》口碑爆棚，国产科幻再迎高光时刻',
    date: '2024-09-02',
    tag: '电影动态',
    summary: '上映首周，《星海归途》便以 8.7 的高分和强劲口碑领跑，被不少观众称为“国产科幻的又一次突破”。',
    cover: 'https://readdy.ai/api/search-image?query=deep%20space%20nebula%20with%20a%20distant%20spaceship%20silhouette%20deep%20blue%20and%20warm%20orange%20nebula%20colors%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-02&orientation=landscape',
    heat: 8860,
    content: [
      { type: 'paragraph', text: '上映首周，《星海归途》交出了一份令人惊喜的答卷。影片以一名宇航员穿越未知星域寻找回家航道为主线，用宏大的宇宙想象包裹着细腻的情感内核。' },
      { type: 'paragraph', text: '不少观众在观影后表示，影片最打动人的并不是炫目的视觉特效，而是那份关于孤独与重逢的真实情感。“看到最后一段，整个影厅都安静了。”一位观众在社交平台上写道。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=astronaut%20helmet%20reflection%20with%20glowing%20blue%20nebula%20and%20warm%20orange%20light%2C%20cinematic%20close%20up%20wide%20composition&width=1000&height=560&seq=news-detail-02&orientation=landscape', caption: '影片中极具诗意的太空场景。' },
      { type: 'paragraph', text: '导演陆川在采访中透露，影片的特效制作历时三年，团队力求每一个星空镜头都“经得起放大看”。正是这种对细节的执着，成就了银幕上的震撼体验。' },
    ],
  },
  {
    id: 'n03',
    title: '新剧《雾隐江湖》开播即登顶，武侠美学回归荧屏',
    date: '2024-09-20',
    tag: '剧集资讯',
    summary: '武侠剧《雾隐江湖》开播首日便登顶热度榜，精美的东方美学与扎实的武打设计让观众直呼“武侠回来了”。',
    cover: 'https://readdy.ai/api/search-image?query=misty%20ancient%20chinese%20mountains%20with%20a%20sword%20fighter%20silhouette%20deep%20blue%20mist%20and%20warm%20lantern%20light%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-03&orientation=landscape',
    heat: 9480,
    content: [
      { type: 'paragraph', text: '开播首日，《雾隐江湖》便以断层优势登顶多个平台的剧集热度榜。这部以江湖恩怨为背景的武侠剧，凭借扎实的武打设计和极具东方韵味的镜头语言，迅速俘获了大批观众。' },
      { type: 'paragraph', text: '与传统武侠剧不同，该剧在打斗场面上大量采用长镜头，减少快速剪辑，让观众能够完整看清每一招每一式。“很久没有看到这么讲究的武打戏了。”有网友评价道。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20swordsman%20in%20flowing%20robes%20standing%20in%20misty%20mountain%20landscape%20warm%20sunset%20light%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-03&orientation=landscape', caption: '剧中诗意盎然的群山场景。' },
      { type: 'paragraph', text: '值得一提的是，剧组坚持实景拍摄，辗转多地取景，只为呈现最真实的山水意境。这份诚意，也成为了该剧口碑发酵的关键。' },
    ],
  },
  {
    id: 'n04',
    title: '国际电影节落幕，亚洲影片斩获多项大奖',
    date: '2024-05-28',
    tag: '行业观察',
    summary: '本届国际电影节上，多部亚洲影片入围主竞赛单元并斩获奖项，亚洲电影的国际影响力持续提升。',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20international%20film%20festival%20red%20carpet%20stage%20with%20warm%20golden%20lighting%20and%20deep%20blue%20backdrop%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-04&orientation=landscape',
    heat: 7230,
    content: [
      { type: 'paragraph', text: '为期两周的国际电影节正式落下帷幕。本届电影节上，亚洲影片表现格外抢眼，多部作品入围主竞赛单元，并最终斩获最佳导演、最佳剧本等多个重要奖项。' },
      { type: 'paragraph', text: '评审团在颁奖词中称赞这些影片“以独特的文化视角与普世的情感表达，展现了亚洲电影日益成熟的创作力量”。近年来，亚洲创作者在国际舞台上的能见度正稳步提升。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=film%20festival%20audience%20applauding%20in%20an%20elegant%20theater%20with%20warm%20golden%20lighting%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-04&orientation=landscape', caption: '颁奖典礼现场，观众为获奖影片鼓掌。' },
      { type: 'paragraph', text: '多位业内人士表示，随着流媒体平台对国际化内容的持续投入，亚洲故事正获得更广阔的传播空间，未来可期。' },
    ],
  },
  {
    id: 'n05',
    title: '流媒体大战升级：平台原创内容进入精品化时代',
    date: '2024-07-11',
    tag: '平台动态',
    summary: '各大流媒体平台纷纷加码原创内容，制作投入持续攀升，剧集与电影的整体品质迎来明显提升。',
    cover: 'https://readdy.ai/api/search-image?query=modern%20streaming%20service%20interface%20glow%20on%20a%20large%20screen%20in%20a%20dark%20room%20deep%20blue%20with%20warm%20orange%20accents%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-05&orientation=landscape',
    heat: 6980,
    content: [
      { type: 'paragraph', text: '过去一年，流媒体平台之间的竞争进入了新阶段。与早期单纯争夺版权不同，如今各平台把重心放在了原创内容的制作上，投入规模屡创新高。' },
      { type: 'paragraph', text: '数据显示，头部平台今年的原创剧集数量同比增长超过三成，单集平均制作成本也明显上升。精品化，正成为整个行业的共同选择。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=modern%20video%20production%20studio%20with%20cameras%20and%20warm%20lighting%20deep%20blue%20background%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-05&orientation=landscape', caption: '一间现代化的影视制作棚。' },
      { type: 'paragraph', text: '对于观众而言，这意味着更多高质量的选择；而对于创作者来说，机遇与挑战并存——只有真正用心的作品，才能在激烈的竞争中脱颖而出。' },
    ],
  },
  {
    id: 'n06',
    title: '《深海回响》幕后揭秘：如何打造沉浸式深海恐惧',
    date: '2024-10-01',
    tag: '幕后花絮',
    summary: '作为年度最受关注的科幻惊悚片，《深海回响》用声音与光影营造出令人窒息的深海体验，幕后团队分享了创作秘诀。',
    cover: 'https://readdy.ai/api/search-image?query=deep%20ocean%20submarine%20exterior%20with%20bioluminescent%20blue%20light%20and%20warm%20orange%20floodlight%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-06&orientation=landscape',
    heat: 8340,
    content: [
      { type: 'paragraph', text: '在《深海回响》中，真正让人感到恐惧的往往不是画面里出现的怪物，而是那无处不在、仿佛来自深渊的“回响”。影片的声音设计，成为观众讨论最多的亮点之一。' },
      { type: 'paragraph', text: '声音总监透露，团队采集了大量真实的海底环境音，并通过特殊的低频处理，让观众在影院中能“用身体感受到压力”。正是这种沉浸式的听觉设计，成就了影片独特的窒息感。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=underwater%20light%20rays%20in%20deep%20blue%20ocean%20with%20a%20submarine%20silhouette%20and%20warm%20orange%20glow%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-06&orientation=landscape', caption: '深海中的光影成为影片的重要叙事元素。' },
      { type: 'paragraph', text: '除了声音，影片对光影的运用同样考究。导演表示，他希望观众能像真正的潜水员一样，在有限的视野中感受未知带来的压迫。' },
    ],
  },
  {
    id: 'n07',
    title: '悬疑剧热潮持续，观众为何越来越爱烧脑故事',
    date: '2024-06-19',
    tag: '深度观察',
    summary: '从《长夜将至》到《真相边缘》，悬疑题材持续霸屏。这股热潮背后，是观众观剧习惯与审美需求的深刻转变。',
    cover: 'https://readdy.ai/api/search-image?query=moody%20detective%20desk%20with%20case%20files%20and%20a%20warm%20desk%20lamp%20in%20a%20dark%20room%20deep%20blue%20shadows%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-07&orientation=landscape',
    heat: 6720,
    content: [
      { type: 'paragraph', text: '打开任意一个视频平台的热播榜，悬疑题材几乎从未缺席。从跨国追凶的《长夜将至》，到层层反转的《真相边缘》，这类剧集总能引发大规模的讨论与二次解读。' },
      { type: 'paragraph', text: '有分析认为，悬疑剧的魅力在于它天然具备“参与感”。观众不再是被动的接受者，而是主动的推理者，弹幕与社交平台上的讨论进一步放大了这种参与体验。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=detective%20looking%20at%20a%20wall%20of%20clues%20connected%20by%20strings%20deep%20blue%20room%20warm%20lamp%20light%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-07&orientation=landscape', caption: '线索墙是悬疑剧中常见的经典元素。' },
      { type: 'paragraph', text: '当然，热潮之下也需警惕同质化。当反转成为套路，真正能打动人心的，依然是扎实的人物塑造与经得起推敲的逻辑。' },
    ],
  },
  {
    id: 'n08',
    title: '经典 IP 翻拍热潮：情怀还是创新',
    date: '2024-04-08',
    tag: '深度观察',
    summary: '越来越多的经典作品被重新搬上荧屏，翻拍热潮引发讨论：观众想要的究竟是熟悉的情怀，还是全新的表达？',
    cover: 'https://readdy.ai/api/search-image?query=vintage%20film%20reels%20and%20old%20movie%20camera%20on%20a%20wooden%20table%20warm%20nostalgic%20light%20deep%20blue%20background%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-08&orientation=landscape',
    heat: 5980,
    content: [
      { type: 'paragraph', text: '从经典武侠到年代传奇，翻拍项目近年来层出不穷。有的凭借全新的技术手段与叙事视角获得好评，也有的因“魔改”而引发争议。' },
      { type: 'paragraph', text: '支持者认为，翻拍让年轻一代有机会重新认识经典；而质疑者则担心，过度的商业化会让原作的精神被稀释。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=old%20classic%20movie%20posters%20and%20film%20canisters%20with%20warm%20vintage%20lighting%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-08&orientation=landscape', caption: '经典作品承载着一代人的记忆。' },
      { type: 'paragraph', text: '或许答案并不在“翻”与“不翻”，而在于创作者是否怀着敬畏之心。真正优秀的翻拍，应当是在致敬经典的同时，完成属于这个时代的全新表达。' },
    ],
  },
  {
    id: 'n09',
    title: '《白色巨塔之下》收官，医疗剧为何总能引发共鸣',
    date: '2024-09-15',
    tag: '剧集资讯',
    summary: '《白色巨塔之下》近日正式收官，这部围绕理想与现实展开的医疗剧，再次证明了医疗题材经久不衰的魅力。',
    cover: 'https://readdy.ai/api/search-image?query=modern%20hospital%20corridor%20at%20night%20with%20warm%20light%20and%20deep%20blue%20shadows%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-09&orientation=landscape',
    heat: 7810,
    content: [
      { type: 'paragraph', text: '随着最后一集播出，《白色巨塔之下》正式收官。这部讲述年轻医生成长的医疗剧，凭借对现实议题的大胆触及和对人性的深刻刻画，收获了持续走高的口碑。' },
      { type: 'paragraph', text: '医疗剧之所以总能引发共鸣，在于它天然处在生与死的交界。医院这个特殊空间，浓缩了人性中最真实的光辉与挣扎。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=doctors%20discussing%20a%20case%20in%20a%20bright%20hospital%20room%20with%20warm%20daylight%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-09&orientation=landscape', caption: '剧中会诊场景展现了团队的专业与默契。' },
      { type: 'paragraph', text: '该剧的成功也再次提醒创作者：无论题材如何变化，能否触达观众内心，始终是一部作品成败的关键。' },
    ],
  },
  {
    id: 'n10',
    title: '从《远东来信》看年代剧的叙事美学升级',
    date: '2024-03-22',
    tag: '深度观察',
    summary: '年代剧《远东来信》以细腻的笔触与考究的美术，重新定义了这类题材的质感，也为年代剧创作提供了新思路。',
    cover: 'https://readdy.ai/api/search-image?query=vintage%20train%20station%20at%20dawn%20with%20warm%20golden%20light%20and%20deep%20blue%20sky%20nostalgic%20atmosphere%2C%20cinematic%20wide%20composition&width=800&height=450&seq=news-10&orientation=landscape',
    heat: 6340,
    content: [
      { type: 'paragraph', text: '《远东来信》自开播以来，凭借极具质感的画面与克制的叙事节奏，成为年代剧中的一股清流。观众评价它“像一封慢慢展开的旧信，值得反复回味”。' },
      { type: 'paragraph', text: '美术团队透露，为了还原创作者心中的时代氛围，剧组在道具与服装上做了大量考据，甚至连一封家书的纸张纹理都反复比对。' },
      { type: 'image', src: 'https://readdy.ai/api/search-image?query=antique%20letters%20and%20a%20vintage%20desk%20with%20warm%20lamp%20light%20nostalgic%20atmosphere%2C%20cinematic%20wide%20shot&width=1000&height=560&seq=news-detail-10&orientation=landscape', caption: '剧中一封家书引出一段跨越战火的往事。' },
      { type: 'paragraph', text: '业内人士指出，年代剧的升级不只是视觉上的，更是叙事观念上的进步。当创作者真正尊重历史与观众，作品自然会散发出持久的魅力。' },
    ],
  },
];